import { Lightning, Utils } from "@lightningjs/sdk"

export default class ParentalButton extends Lightning.Component {
    static override _template() {
        return {
            w: (w) => w,
            h: 60,
            rect: true,
            collision: true,
            zIndex: 83,
            color: 0xff111111,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 6 },
            flex: {
                direction: "row",
                alignItems: "center",
                justifyContent: "center",
                padding: 10,
            },
            Icon: {
                w: 0,
                h: 0,
                visible: false,
                flexItem: { marginRight: 0 },
            },
            Label: {
                text: {
                    text: this.bindProp('label'),
                    fontSize: 28,
                    textColor: 0xffffffff,
                },
            },
        };
    }

    // override _getFocused(): Lightning.Component | null | undefined {
    //     return this.tag('Button')!
    // }

    set icon(src) {
        if (src) {
            this.tag("Icon").patch({
                w: 50,
                h: 50,
                flexItem: { marginRight: 10 },
                src: Utils.asset(src),
                visible: true,
            });
        }
    }

    private _focusBgColor = 0xffffffff;
    private _unfocusBgColor = 0xff111111;
    private _focusTextColor = 0xff000000;
    private _unfocusTextColor = 0xffffffff;

    set theme(val: 'default' | 'red') {
        if (val === 'red') {
            this._unfocusBgColor = 0xff330000;
            this._focusBgColor = 0xff990000;
            this._unfocusTextColor = 0xffffffff;
            this._focusTextColor = 0xffffffff;
        } else {
            this._unfocusBgColor = 0xff111111;
            this._focusBgColor = 0xffffffff;
            this._unfocusTextColor = 0xffffffff;
            this._focusTextColor = 0xff000000;
        }
        this._updateTheme();
    }

    private _updateTheme() {
        const isFocused = this.hasFocus();
        this.patch({
            color: isFocused ? this._focusBgColor : this._unfocusBgColor,
            Label: { text: { textColor: isFocused ? this._focusTextColor : this._unfocusTextColor } }
        });
    }

    override _focus() {
        this.patch({
            smooth: { color: this._focusBgColor, scale: 1.1 },
            Label: { text: { textColor: this._focusTextColor } }
        });
    }

    override _unfocus() {
        this.patch({
            smooth: { color: this._unfocusBgColor, scale: 1 },
            Label: { text: { textColor: this._unfocusTextColor } }
        });
    }

    private _mode: string = 'default';

    set mode(val: 'default' | 'disabled' | 'unfocused') {
        this._mode = val;
        this.alpha = val === 'disabled' ? 0.4 : 1;
    }

    get mode() {
        return this._mode;
    }

}
